import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppComponent } from '../app.component';
import { Service } from '../services';
import { GlobalService } from '../global.service';
import { LoadingScreenService } from '../services/loading-screen/loading-screen.service';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material';
import { Subscription } from "rxjs";
import { AngularFireAnalytics } from '@angular/fire/analytics';

@Component({
  selector: 'app-usage',
  templateUrl: './usage.component.html',
  styleUrls: ['./usage.component.sass']
})
export class UsageComponent implements OnInit {
  public tabActive = 'Mi Consumo';
  public selectBan;
  public currentList;
  public postpago;
  public prepago;
  public telefoniaFijo;
  public totalAccountList;
  public type;
  public expand = [];
  public SubscriberInfo = [];
  public token: string = sessionStorage.getItem("token");
  loadObserver: Subscription;
  public info = [];
  public cycle = [];
  public productTypeField = [];
  public selTab: number;
  public cycleDateField;
  public displayNameField;
  public usage2 = [];
  public usage4: any;
  public typepq = 'PL-ACT';
  public mixed = false;
  public subscribernumber;
  constructor(public AngularFireAnalytics: AngularFireAnalytics, private router: Router, public appComponent: AppComponent, private loadingScreenService: LoadingScreenService, private services: Service, public global: GlobalService, public dialog: MatDialog, private route: ActivatedRoute) {
    this.AngularFireAnalytics.setCurrentScreen("Mi Consumo");
    this.AngularFireAnalytics.logEvent("Mi Consumo-Screenview");
  }
  ngOnInit() {
    if (this.global.sessionReview() == true) {
      this.expand[0] = true;
      this.selTab = 1;
      this.getId();
      this.selectBan = atob(sessionStorage.getItem("selectBan"));
      this.info = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).SubscriberInfo;
      this.cycleDateField = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo.cycleDateField;
      this.subscribernumber = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).SubscriberInfo.subscriberNumberField;
      this.global.mask(this.subscribernumber);
      this.mixed;
      this.usage_info();
      this.selectBan = atob(sessionStorage.getItem("selectBan"));
      this.loadingScreenService.stopLoading();
      this.loadObserver = this.global.loadObserver.subscribe((value: number) => {
        this.dataLoading(value);
      });
    }
  }
  check(value) {
    if (value == 'G') {
      this.mixed = true;
    }
  }
  usage_info() {
    let counter1 = 0;
    let iDLocal: number = 0;
    let counter2 = 0;
    let percentage: number = 0;
    let counterPad = 0;
    let usage = '{';
    usage += '"subscribers":';
    usage += '[';
    for (var i = 0; i < this.info.length; i++) {
      this.check(this.info[i].productTypeField);
      counter2 = 0;
      counterPad = 0;
      if (counter1 > 0) { usage += ','; }
      usage += '{';
      usage += '"subscriber":';
      usage += '[';
      this.info[i].usageInfoField.dataOffersField.map(function (offers) {
        if (counter2 > 0) { usage += ','; }
        usage += '{';
        usage += '"offerGroup":"' + offers.offerGroupField + '",';
        usage += '"DPlanName":"' + offers.displayNameField + '",';
        usage += '"Quota":"' + offers.quotaField + '",';
        usage += '"DLocalTop":"' + offers.quotaTextField + '",';
        usage += '"iDLocal":"' + offers.usedField + '",';
        usage += '"iDLocalText":"' + offers.usedTextField + '",';
        if (parseFloat(offers.quotaField) > 0) {
          if (offers.usedField === null) {
            iDLocal = 0;
          }
          else {
            iDLocal = offers.usedField;
          }
          percentage = (iDLocal * 100) / parseFloat(offers.quotaField);
          percentage = parseInt(percentage.toString());
        }
        usage += '"percentage":' + percentage + ',';
        if (offers.offerGroupField.search('BASE') > -1) {
          usage += '"type":"PL-ACT"';
        }
        else if (offers.offerGroupField.search("NT_ROAM_GRANEL") > -1) {
          usage += '"type":"DR"';
        }
        else {
          if (counterPad === 0) {
            usage += '"type":"PQ-AD"';
          }
          else {
            usage += '"type":""';
          }
          counterPad++;
        }
        usage += '}';
        counter2++;
      });
      usage += '],"countDR":' + counter2 + ',"countPQAD":' + counterPad + ',"productType":"' + this.info[i].productTypeField + '"';
      usage += '}';
      counter1++;
    }
    usage += ']';
    usage += '}';
    this.usage2 = JSON.parse(usage).subscribers;
  }
  loadCanvas() {
    let objHtml;
    for (let i = 0; i < this.usage2.length; i++) {
      for (let j = 0; j < this.usage2[i].subscriber.length; j++) {
        objHtml = 'idCanvasPaq_' + i + '_' + j;
        this.global.pid2D(document.getElementById(objHtml),this.usage2[i].subscriber[j].percentage);
      }
    }
  }
  refreshDataTo() {
    if (this.global.validateSession() === true) {
      let index = parseInt(event.target["selectedIndex"]);
      let ban = this.currentList[index].account;
      sessionStorage.setItem("selectBan", btoa(ban));
      this.initializeData();
    }
  }
  initializeData() {
    this.global.refreshDataTo(this.token);
  }
  dataLoading(sw) {
    if (this.postpago == true) {
      this.type = "postpaid";
    }
    else if (this.prepago == true) {
      this.type = "prepaid";
    }
    else if (this.telefoniaFijo == true) {
      this.type = "fixed";
    }
    this.info = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).SubscriberInfo;
    this.expand[0] = true;
    this.selTab = 1;
    this.getId();
    this.selectBan = atob(sessionStorage.getItem("selectBan"));
    this.usage_info();
    this.cycleDateField = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo.cycleDateField;
    this.selectBan = atob(sessionStorage.getItem("selectBan"));
    this.global.mask(this.subscribernumber);
    setTimeout(() => {
      this.loadCanvas();
    }, 2000);
    this.loadingScreenService.stopLoading();
  }
  updateExpand(index) {
    if (this.global.validateSession() === true) {
      this.expand[index] = !this.expand[index];
    }
  }
  statusChange(sw) {
    this.global.validateSession();
    this.selTab = sw;
  }
  getId() {
    if (this.route.firstChild) {
      var id = this.route.firstChild.snapshot.params.id;
      if (id == '1') {
        this.selTab = 1;
      }
      else if (id == '2') {
        this.selTab = 2;
      }
      else {
        this.selTab = 1;
        this.router.navigate(['usage']);
      }
    }
  }
}